import decorators from '../jsonApiParser/decorators'

/*
 * Takes a collection, which can be an array or object,
 * and loops through it applying a callback to each
 * item in the collection. Helper method that
 * effectively replaces the native forEach method to be
 * able to run it against objects as well.
 */
export const each = (collection, callback) => {
  if (!collection) {
    return
  }
  Object.entries(collection).forEach(([key, value]) => {
    callback(value, key)
  })
}

/*
 * Takes an entity, its meta, and its relationships
 * and flattens them into a simple object.
 */
export const flatten = (data, extraMeta) => {
  const newData = { ...data }
  const meta = { ...newData.meta, ...extraMeta }
  const relationships = {}

  each(newData.relationships, (relationship, alias) => {
    if (relationship.data) {
      if (Array.isArray(relationship.data)) {
        if (!relationship.data.length) {
          relationships[alias] = []
          return
        }
        each(relationship.data, (rel) => {
          relationships[alias] = relationships[alias] || []
          relationships[alias].push(rel)
        })
        return
      }
      if (relationship.data.id) {
        relationships[alias] = relationship.data
      }
    } else {
      relationships[alias] = null
    }
  })

  delete newData.attributes
  delete newData.relationships

  return {
    ...newData,
    ...meta,
    ...data.attributes,
    relationships,
    id: data.id,
    type: data.type,
  }
}

/**
 * Takes data and runs it through any available
 * decorators. For example, users need to have
 * additional data that we don't get back from
 * the server, like fullName.
 */
export const decorate = (data) => {
  let decoratedData = { ...data }

  if (typeof Object.entries(data)[0][1] === 'object') {
    each(decoratedData, (entity) => {
      if (entity && decorators[entity.type]) {
        decoratedData[entity.id] = decorators[entity.type](entity)
      }
    })
    return decoratedData
  }

  if (decorators[data.type]) {
    decoratedData = decorators[data.type](data)
  }
  return decoratedData
}
